import React, { useEffect, useMemo, useState } from 'react'
import InventoryTabs from '../component/InventoryTabs'
import { useGetPolicies } from 'features/insurance/api/getPolicies'
import { Box, Flex } from 'components/elements'
import { Spinner } from 'components/elements'
import { StyledContainer } from 'features/insurance/pages/Insurance'
import { IncidentArray } from 'configs/constants'
const Invertory = () => {
  const { data: activePolicy, isLoading: isLoadingPolicies } = useGetPolicies()
  //filter out the services that are not active and Patch and Secure
  const activeServices = useMemo(
    () =>
      activePolicy?.data?.services
        ?.filter((service: { isActive: boolean; serviceId: number }) => service.isActive && service.serviceId !== 6)
        ?.map((service: { serviceId: number }) => service.serviceId) || [],
    [activePolicy?.data?.services]
  )

  const [tabNumber, setTabNumber] = useState<number>(activeServices?.[0])

  useEffect(() => {
    if (activeServices?.[0]) {
      setTabNumber(activeServices?.[0])
    }
  }, [activeServices, setTabNumber])

  return (
    <>
      {isLoadingPolicies ? (
        <Flex justify="center" align="center" css={{ m: '10rem auto' }}>
          <Spinner />
        </Flex>
      ) : (
        <StyledContainer>
          <Box as="h2" css={{ mb: '$5' }}>
            {tabNumber && IncidentArray[tabNumber - 1]}
          </Box>
          <InventoryTabs activeServices={activeServices} setTabNumber={setTabNumber} tabNumber={tabNumber} />
        </StyledContainer>
      )}
    </>
  )
}

export default Invertory
